import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { obtenerMercaderiaSecada, obtenerMercaderiaSecadaDosMas } from '../../actions/listados'
import LiquidacionMercaderiaSecadaView from '../../components/listados/LiquidacionMercaderiaSecadaView'
import LiquidacionMercaderiaSecadaDosMasView from '../../components/listados/LiquidacionMercaderiaSecadaDosMasView'

function LiquidacionMercaderiaSecada (props) {
  const { obtenerMercaderiaSecada, obtenerMercaderiaSecadaDosMas } = props

  useEffect(() => {
    obtenerMercaderiaSecada(new Date(), new Date())
    obtenerMercaderiaSecadaDosMas(new Date(), new Date())
  }, [obtenerMercaderiaSecada, obtenerMercaderiaSecadaDosMas])

  const actualizarFechas = (fechaD, fechaH) => {
    obtenerMercaderiaSecada(fechaD, fechaH)
    obtenerMercaderiaSecadaDosMas(fechaD, fechaH)
  }

  return (
    <>
      <div className='container-entre-fechas'>
        <DatePicker
          selectRange
          disabledFuture
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>

      <LiquidacionMercaderiaSecadaView />

      <div style={{ marginTop: '3%' }}>
        <LiquidacionMercaderiaSecadaDosMasView />
      </div>

    </>
  )
}

const mapActionsToProps = {
  obtenerMercaderiaSecada,
  obtenerMercaderiaSecadaDosMas
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(LiquidacionMercaderiaSecada)
